module.exports = __webpack_public_path__ + "assets/img/timeLine_img2.36b0a2e9.png";